// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAaVEo1b01Dz1t2NW-RbK0oaY2ppK3KND0",
    authDomain: "hyperliquid-website-9cf26.firebaseapp.com",
    projectId: "hyperliquid-website-9cf26",
    storageBucket: "hyperliquid-website-9cf26.firebasestorage.app",
    messagingSenderId: "1089703171774",
    appId: "1:1089703171774:web:2adac0b958f8116701f0ef",
    measurementId: "G-JQS6L7K9CK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);